import React, { Fragment } from 'react';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  Col,
  Icon,
  Row
} from 'framework7-react';
import PropTypes from 'prop-types';
import OpenMainInfoLink from '../common/OpenMainInfoLink';
import II18 from '../translate/II18';

class DesktopWindow extends React.Component {
  componentDidMount() {
    this.$f7.tooltip.create({
      targetEl: '.deadlineDateTooltip',
      text: II18.get('home_deadline_title', this.props.endDate),
      offset: -35
    });
  }

  render = () => {
    return (
      <Card className="paperfly-card desktop-card">
        <CardHeader className="no-border">
          <div>
            <Row style={{ alignItems: 'center' }}>
              <Col width="10" style={{ height: 65 }}>
                <img
                  alt={this.props.companyName || 'Paperfly'}
                  src={this.props.companyLogo || '/favicon512.png'}
                  width="60"
                  height="60"
                  style={{
                    borderRadius: 5,
                    border: '2px solid #d5dee6',
                    background: '#fff'
                  }}
                />
              </Col>
              <Col width="80">
                <Row>
                  <span
                    data-testid="cardCompanyName"
                    style={{
                      fontSize: 24,
                      fontWeight: 500,
                      marginTop: 0
                    }}
                  >
                    {this.props.companyName || 'Paperfly'}
                  </span>
                </Row>
                <Row>
                  <span
                    data-testid="cardCaseName"
                    style={{ fontSize: 18, opacity: 0.9 }}
                  >
                    {this.props.caseName}
                  </span>
                </Row>
              </Col>

              <Col width="10">
                {!this.props.closed && (
                  <OpenMainInfoLink
                    style={{
                      display: 'block',
                      width: 38,
                      height: 38
                    }}
                  >
                    <label className={'screenreader'}>Information</label>
                    <Icon size="25" icon="fas fa-info-circle" />
                  </OpenMainInfoLink>
                )}
              </Col>
            </Row>
          </div>
        </CardHeader>
        <CardContent>{this.props.children}</CardContent>
        <CardFooter className="no-border">
          {this.props.pageFooterContent ? (
            this.props.pageFooterContent
          ) : (
            <Fragment>
              {this.props.endDate && !this.props.closed ? (
                <label>
                  <span
                    className={'deadlineDateTooltip'}
                    style={{
                      fontSize: 13,
                      color: this.props.expired ? 'red' : '#8e8e93'
                    }}
                  >
                    <Icon
                      style={{ marginRight: 8, marginTop: -4 }}
                      size="18"
                      ios="material:alarm"
                      md="f7:alarm"
                    />
                    <span data-testid="deadlineDate">{this.props.endDate}</span>
                  </span>
                </label>
              ) : (
                <div></div>
              )}

              {this.props.companyName &&
                !this.props.expired &&
                !this.props.closed && (
                  <label
                    data-testid="securityInfo"
                    style={{ float: 'right', fontSize: 13, color: '#8e8e93' }}
                  >
                    <Icon f7="lock" size={18} />{' '}
                    <II18
                      params={[
                        this.props.companyName,
                        II18.get(
                          this.props.scanEnded
                            ? 'home_security_info_part_may'
                            : 'home_security_info_part_will'
                        )
                      ]}
                      html
                    >
                      home_security_info
                    </II18>
                  </label>
                )}
            </Fragment>
          )}
        </CardFooter>

        {this.props.popup && (
          <div>
            <div
              className="popup-backdrop"
              style={{
                visibility: 'visible',
                opacity: 0.5,
                zIndex: 5,
                position: 'absolute'
              }}
            />
            {this.props.popup()}
          </div>
        )}
      </Card>
    );
  };
}

DesktopWindow.propTypes = {
  companyLogo: PropTypes.string,
  companyName: PropTypes.string,
  companyEmail: PropTypes.string,
  caseName: PropTypes.string,
  endDate: PropTypes.string,
  scanEnded: PropTypes.bool,
  closed: PropTypes.bool,
  expired: PropTypes.bool,
  popup: PropTypes.any,
  children: PropTypes.any,
  pageFooterContent: PropTypes.any
};

export default DesktopWindow;
